import { ActionTree } from 'vuex';
import {
  getPersonalDataPolicy as apiGetPersonalDataPolicy,
  getChatBotPersonalDataPolicy as apiGetChatBotPersonalDataPolicy,
  getChatBotPersonalDataAgreement as apiGetChatBotPersonalDataAgreement,
} from '@/api/public';
import { IGetChatBotPersonalData } from '@/@types/api/public';

export default {
  actions: <ActionTree<any, any>>{
    async getPersonalDataPolicy(_, payload): Promise<any> {
      return await apiGetPersonalDataPolicy(payload);
    },

    async getChatBotPersonalDataPolicy(
      _,
      payload: IGetChatBotPersonalData,
    ): Promise<string> {
      return await apiGetChatBotPersonalDataPolicy(payload);
    },

    async getChatBotPersonalDataAgreement(
      _,
      payload: IGetChatBotPersonalData,
    ): Promise<string> {
      return await apiGetChatBotPersonalDataAgreement(payload);
    },
  },
};
